import { Slider1, Slider2, Slider3, Slider4, Slider5 } from '../images';
import { useEffect, useRef } from 'react';
import { Autoplay, EffectFade, Navigation, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { ArrowLeftIcon, ArrowRightIcon } from '@heroicons/react/24/outline';
import { Col, Container, Row } from 'react-bootstrap';

const HeroSlider = () => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const swiperRef = useRef<any>(null);


  const sliders = [
    Slider1,
    Slider2,
    Slider3,
    Slider4,
    Slider5
  ]

  useEffect(() => {
    if (swiperRef.current && prevRef.current && nextRef.current) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, []);
  

  return (
    <Container className="hero overflow-hidden py-5">
      <Row>
        <Col sm={12} lg={12} md={12} xs={12}>
          <div className="hero-content open-up" data-aos="zoom-out">
            <Swiper
              onSwiper={(swiper) => (swiperRef.current = swiper)}
              navigation={{
                nextEl: nextRef.current,
                prevEl: prevRef.current,
              }}
              speed={1000}
              slidesPerView={1}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              loop={true}
              // onInit={(swiper) => {
              //   // @ts-ignore
              //   swiper.params.navigation.prevEl = prevRef.current;
              //   // @ts-ignore
              //   swiper.params.navigation.nextEl = nextRef.current;
              //   swiper.navigation.init();
              //   swiper.navigation.update();
              // }}
              effect='fade'
              fadeEffect={{ crossFade: true }}
              pagination={{
                dynamicBullets: true,
                el: '.hero-swiper-pagination',
                clickable: true,
                renderBullet: (index, className) => {
                  return `<span 
                    class="${className}" 
                    style="width: 15px; height: 15px; margin: 0 6px;"
                  ></span>`;
                },
              }}
              modules={[Navigation, EffectFade, Pagination, Autoplay]}
              className="hero-swiper"
            >
              {sliders.map((slider: string, i:number) => (
                <SwiperSlide 
                  key={i} 
                  className="hero-slide"
                  style={{
                    width: '100%',
                    borderRadius: '0.5rem',
                    backgroundImage:`url(${slider})`, 
                    backgroundRepeat: 'no-repeat', 
                    backgroundPosition: 'center center',
                    backgroundSize: 'cover',
                  }}>
                </SwiperSlide>
              ))}
            </Swiper>
            <div 
              className="hero-swiper-pagination d-flex justify-content-center"
              style={{
                position: 'absolute',
                textAlign: 'center',
                transition: '.3s opacity',
                zIndex: 10,
                left: '50%',
                transform: 'translateX(-50%)',
                whiteSpace: 'nowrap',
                width: '50%',
                bottom: '3.5rem'
              }}  
            ></div>
            <button className="icon-arrow icon-arrow-right" ref={prevRef}><ArrowRightIcon /></button>
            <button className="icon-arrow icon-arrow-left" ref={nextRef}><ArrowLeftIcon /></button>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default HeroSlider;